import assembler from './assembler';

import './Component/BrowserUpdate';
import './Component/ContactStageForm';
import './Component/ContentSlider';
import './Component/DatePicker';
import './Component/OffCanvas';
import './Component/ScrollTo';
import './Component/SiteNavigation';
import './Component/TiledTeaser';

function initialize() {
	app: assembler.run();
}

function handleOverlayer() {
    document.removeEventListener("DOMContentLoaded", handleOverlayer);

    const $overlayer = document.querySelector("[data-select='overlayer']");

    if ($overlayer && !$overlayer.classList.contains('isInBackend')) {
        document.body.append($overlayer);

        window.setTimeout(() => {
            $overlayer.classList.add('appear');
        }, 900);

        const $closer = $overlayer.querySelector('button');
        $closer.addEventListener('click', () => {
            document.body.removeChild($overlayer);
        }, {once: true});
    }
}

document.addEventListener("DOMContentLoaded", handleOverlayer);

document.addEventListener('DOMContentLoaded', initialize);
